const orderStatuses =
{
    tabs:
    {
        basic: 'Statusy zamówień',
        payment: 'Mapowanie statusów płatności'
    },
    title: 'Statusy zamówień',
    formsTable:
    {
        title: "Statusy zamówień",
        headers: {
            name: 'Nazwa',
            description: 'Opis',
            erpOrderStatusName: 'Nazwa z ERP'
        },
        tooltips: {
            add: 'Dodaj status zamówienia',
            edit: 'Edytuj status zamówienia',
            remove: 'Usuń status zamówienia'
        },
        editModal:{
            title: 'Edycja statusu zamówienia',
            inputs:{
                name: 'Nazwa',
                description: 'Opis',
                erpOrderStatusId: 'Status zamówienia z systemu ERP',
                color: 'Kolor',
                colorButton: 'Wybierz',
            },
            buttons:{
                remove: 'WRÓĆ',
                save: 'ZAPISZ'
            },
            nameModalHeader: 'Edycja nazwy statusu zamówienia',
            descriptionModalHeader: 'Edycja opisu statusu zamówienia',
            tags: {
                paymenterror: 'Status zostanie ustawiony autonatycznie w przypadku, gdy płatność elektroniczna się nie powiedzie',
                new: 'Status zostanie ustawiony automatycznie dla nowego zamówienia, przed zainicjowaniem płatności elektronicznej',
                waitingforpayment: 'Status zostanie ustawiony automatycznie po zainicjowaniu płatności elektronicznej, ale przed jej zakończeniem',
                paymentrejected: 'Status zostanie ustawiony autonatycznie w przypadku, gdy użytkownik odrzuci płatność elektroniczną',
                completing: 'Status zostanie ustawiony automatycznie po pozytywnym zakończeniu płatności elektronicznej, bądź w przypadku wybrania płatności przy odbiorze',
                sent: 'Status SENT',
                rejected: 'Status REJECTED',
            }
        },
        deleteModal: {
            header: 'Usuń status zamówienia',
            body: 'Czy napewno chcesz usunąć wybrany status zamówienia?',
            confirm: 'Usuń',
            cancel: 'Wróć'
        }
    },
    paymentRulesTable:
    {
        title: 'Reguły mapowania statusów płatności',
        headers: {
            name: 'Nazwa',
            previousPaymentStatus: 'Poprzedni status płatności',
            paymentStatus: 'Status płatności',
            currentOrderStatus: 'Bieżący status zamówienia',
            targetOrderStatus: 'Docelowy status zamówienia',
            priority: 'Priorytet',
            enabled: 'Aktywna',
            actions: 'Akcje'
        },
        tooltips: {
            add: 'Dodaj regułę',
            edit: 'Edytuj regułę'
        },
        buttons: {
            create: 'DODAJ'
        },
        deleteModal: {
            header: 'Usuń regułę',
            body: 'Czy na pewno chcesz usunąć wybraną regułę?',
            confirm: 'Usuń',
            cancel: 'Wróć'
        },
        editModal: {
            title: 'Edycja reguły mapowania',
            labels: {
                name: 'Nazwa',
                previousPaymentStatus: 'Poprzedni status płatności',
                paymentStatus: 'Status płatności',
                currentOrderStatus: 'Bieżący status zamówienia',
                orderStatus: 'Docelowy status zamówienia',
                priority: 'Priorytet',
                enabled: 'Aktywna'
            },
            buttons: {
                confirm: 'ZAPISZ',
                cancel: 'ANULUJ'
            }
        },
        errors: {
            paymentStatusRequired: 'Wybierz status płatności.',
            orderStatusRequired: 'Wybierz docelowy status zamówienia.'
        }
    }
};

export default orderStatuses;